import React from 'react';
import { useTranslation } from 'react-i18next';
import { getCardApiValue, formatValue } from '../helpers';
import { checkKpiType } from '@flexo/general';
import parse from 'html-react-parser';

interface InformationCardContentLabelValueUnitProps {
  description: string;
  value: string;
  overviewKpiApiData: any[];
  kpiContext: string;
  currencyFields: string[];
  id: string;
}

const InformationCardContentLabelValueUnit: React.FC<InformationCardContentLabelValueUnitProps> = ({ description, value, overviewKpiApiData, kpiContext, currencyFields, id }) => {
  const { t } = useTranslation();
  const valueObj = getCardApiValue(value, overviewKpiApiData, currencyFields);
  return (
    <span key={`${id}-label-value-unit`} className="paragraph">
      {parse(
        t(description, {
          value: formatValue(valueObj?.value || '-.-', kpiContext, checkKpiType),
          unit: valueObj?.unit || '',
        })
      )}
    </span>
  );
};

export default InformationCardContentLabelValueUnit; 